(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._calendar_1w0de_1{--swui-calendar-day-width: 40px;--swui-calendar-day-height: 38px;--swui-calendar-day-border-radius: 4px;--swui-calendar-week-number-bg-color: transparent;--swui-calendar-week-number-text-color: var(--lhds-color-ui-500);--swui-calendar-week-number-clickable-text-color: var(--lhds-color-ui-500);--swui-calendar-week-day-text-color: var(--lhds-color-ui-500);--swui-calendar-week-day-clickable-text-color: var(--lhds-color-ui-500);--swui-calendar-wrapper-selected-border: var(--swui-primary-action-color);--swui-calendar-wrapper-selected-background: var(--swui-primary-action-color);--swui-calendar-wrapper-range-border: var(--lhds-color-blue-100);--swui-calendar-wrapper-range-background: var(--lhds-color-blue-100);--swui-calendar-wrapper-today-border: var(--lhds-color-ui-200);--swui-calendar-wrapper-today-background: var(--lhds-color-ui-200);--swui-calendar-text-selected-color: #fff;--swui-calendar-text-disabled-color: var(--swui-text-disabled-color);--swui-calendar-text-in-other-month-color: var(--swui-text-disabled-color)}._calendar_1w0de_1 table{border-spacing:0 4px}._calendar_1w0de_1 span{line-height:100%}._calendar_1w0de_1 tr td:last-child{border-top-right-radius:var(--swui-calendar-day-border-radius);border-bottom-right-radius:var(--swui-calendar-day-border-radius)}._calendar_1w0de_1 tr td:nth-child(2){border-top-left-radius:var(--swui-calendar-day-border-radius);border-bottom-left-radius:var(--swui-calendar-day-border-radius)}._calendar_1w0de_1 td{padding:0;width:var(--swui-calendar-day-width);height:var(--swui-calendar-day-height)}._timePicker_1w05d_1{overflow:hidden;width:180px}._timePickerColumn_1w05d_6{overflow-y:hidden;flex:1}._timePickerColumn_1w05d_6:hover{overflow-y:scroll}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { jsx as c, jsxs as R, Fragment as Dt } from "react/jsx-runtime";
import { Box as N, Text as ct, Clickable as Ut, Row as E, Space as W, Spacing as ye, Column as B, Indent as gt, SeparatorLine as pe, parseIntElseUndefined as Jt, useBoolean as Yt, useDelayedFalse as Ht } from "@stenajs-webui/core";
import { FlatButton as A, PrimaryButton as dt, stenaAngleLeft as Wt, stenaAngleRight as Ot, stenaArrowLeft as be, stenaArrowRight as Qt, stenaAngleLeftDouble as Xt, stenaAngleRightDouble as Zt, TextInputButton as ke, stenaCalendar as mt, Icon as Ft, stenaArrowWideRight as Se, stenaClock as vt, stenaAngleDown as Me } from "@stenajs-webui/elements";
import { isAfter as et, eachDayOfInterval as $t, isSameDay as j, endOfMonth as Vt, startOfMonth as te, min as Re, addDays as G, max as Ee, subDays as ht, format as P, getISOWeek as Bt, getDate as Ct, startOfWeek as ee, addWeeks as Te, getMonth as tt, getWeek as ne, getYear as wt, getISODay as Ae, addHours as xe, isBefore as Ce, parse as ot, addMonths as Ie, addYears as Ne, subMonths as Ye, subYears as He, setWeek as Le, isValid as Pe } from "date-fns";
import { enGB as jt } from "date-fns/locale";
import { last as Ue, startCase as re, chunk as se, range as zt, debounce as We, padStart as Oe } from "lodash";
import * as ie from "react";
import { useMemo as x, useState as S, useEffect as q, useCallback as g, useRef as _ } from "react";
import It from "@emotion/styled";
import { TextInput as nt, TextInputBox as $e } from "@stenajs-webui/forms";
import { useTippyInstance as Be, Popover as pt } from "@stenajs-webui/tooltip";
import { cssColor as ce } from "@stenajs-webui/theme";
const X = {
  yearAndMonth: "yyyy-MM",
  fullDate: "yyyy-MM-dd",
  fullMonthName: "LLLL",
  fullDateAndTime: "yyyy-MM-dd HH:mm",
  fullDateAndTimeSystem: "yyyy-MM-ddTHH:MM",
  weekDayName: "EEEE",
  // Tuesday
  weekDayNameShort: "EEE",
  // Tue
  dateAndMonth: "d MMM",
  // 2 Jan
  monthAndDate: "MMM do"
  // Jan 2nd
}, yt = (t = {}, e, n) => {
  if (e && n && et(n, e))
    return $t({ start: e, end: n }).reduce(
      (s, i) => {
        const d = j(i, e), o = j(i, n);
        return Q(s, i, d ? ["selected", "selectedStart", "range"] : o ? ["selected", "selectedEnd", "range"] : ["range"]);
      },
      t
    );
  let r = t;
  return e && (r = Q(r, e, ["selected", "singleSelected"])), n && (r = Q(r, n, ["selected", "singleSelected"])), r;
}, je = (t = {}, e, n, r) => ze(
  t,
  e,
  n,
  te(r),
  Vt(r)
), ze = (t = {}, e, n, r, s) => e && n ? yt(
  t,
  Ee([e, ht(r, 1)]),
  Re([n, G(s, 1)])
) : yt(t, e, n), ur = (t, e, n) => {
  const r = P(e, X.yearAndMonth), s = Bt(e), i = Ct(e);
  return {
    ...t,
    [r]: {
      ...t && t[r],
      [s]: {
        ...t && t[r] && t[r][s],
        [i]: {
          ...t && t[r] && t[r][s] && t[r][s][i],
          ...n
        }
      }
    }
  };
}, hr = (t, e, n) => {
  const r = P(e, X.yearAndMonth), s = Bt(e), i = Ct(e);
  return {
    ...t,
    [r]: {
      ...t && t[r],
      [s]: {
        ...t && t[r] && t[r][s],
        [i]: {
          ...t && t[r] && t[r][s] && t[r][s][i],
          ...n(
            t && t[r] && t[r][s] && t[r][s][i]
          )
        }
      }
    }
  };
}, Q = (t, e, n) => {
  const r = e.getMonth() + 1, s = `${e.getFullYear()}-${r < 10 ? "0" : ""}${r}`, i = Bt(e), d = Ct(e), o = t && t[s] && t[s][i] && t[s][i][d];
  return {
    ...t,
    [s]: {
      ...t && t[s],
      [i]: {
        ...t && t[s] && t[s][i],
        [d]: oe(o, n)
      }
    }
  };
}, oe = (t, e) => ({
  ...t,
  highlights: [...(t == null ? void 0 : t.highlights) ?? [], ...e]
}), Dr = (t, e, n) => {
  const r = e.days[0].date, s = r.getMonth() + 1, i = `${r.getFullYear()}-${s < 10 ? "0" : ""}${s}`, d = e.weekNumber;
  let o = t;
  e.days.forEach((D) => {
    o = Q(o, D.date, n);
  });
  const l = o && o[i] ? o[i][d] : void 0, a = l && l.highlights ? [...l.highlights, ...n] : n, f = {
    ...l,
    highlights: a
  };
  return {
    ...o,
    [i]: {
      ...t && t[i],
      [d]: f
    }
  };
}, _e = (t, e) => {
  var s;
  if (!e.days.length)
    return { ...t };
  const n = e.days[0].date, r = (s = Ue(e.days)) == null ? void 0 : s.date;
  return {
    ...yt(t, n, r)
  };
}, Je = (t, e) => x(() => t ? Q(e, /* @__PURE__ */ new Date(), ["today"]) : e, [t, e]);
var L = /* @__PURE__ */ ((t) => (t[t.JANUARY = 0] = "JANUARY", t[t.FEBRUARY = 1] = "FEBRUARY", t[t.MARCH = 2] = "MARCH", t[t.APRIL = 3] = "APRIL", t[t.MAY = 4] = "MAY", t[t.JUNE = 5] = "JUNE", t[t.JULY = 6] = "JULY", t[t.AUGUST = 7] = "AUGUST", t[t.SEPTEMBER = 8] = "SEPTEMBER", t[t.OCTOBER = 9] = "OCTOBER", t[t.NOVEMBER = 10] = "NOVEMBER", t[t.DECEMBER = 11] = "DECEMBER", t))(L || {}), Ke = /* @__PURE__ */ ((t) => (t[t.SUNDAY = 0] = "SUNDAY", t[t.MONDAY = 1] = "MONDAY", t[t.TUESDAY = 2] = "TUESDAY", t[t.WEDNESDAY = 3] = "WEDNESDAY", t[t.THURSDAY = 4] = "THURSDAY", t[t.FRIDAY = 5] = "FRIDAY", t[t.SATURDAY = 6] = "SATURDAY", t))(Ke || {});
const Kt = (t, e, n, r) => {
  const s = [];
  for (let i = 0; i < n; i++)
    s.push(de(t, e + i, r));
  return s;
}, de = (t, e, n) => {
  const r = t + Math.floor(e / 12), s = e % 12, i = new Date(r, s, 1);
  return {
    monthString: P(i, X.yearAndMonth),
    name: re(
      P(i, X.fullMonthName, { locale: n })
    ),
    year: r,
    monthInYear: s,
    weeks: Ge(r, s, n)
  };
}, Ge = (t, e, n, r = !0) => {
  const s = new Date(t, e, 1), i = ee(s, { locale: n }), d = [];
  for (let o = 0; o < 6; o++) {
    const l = _t(Te(i, o), n);
    if (o > 0 && l.startMonth !== e && !r)
      return d;
    d.push(l);
  }
  return d;
}, _t = (t, e) => {
  const n = tt(G(t, 7)) !== tt(t);
  return {
    weekNumber: ne(t, { locale: e }),
    startMonth: tt(t),
    startYear: wt(t),
    endMonth: tt(G(t, 6)),
    endYear: wt(G(t, 6)),
    days: Qe(t, e),
    isLastWeekOfMonth: n
  };
}, qe = (t, e) => {
  const n = Ae(t);
  return {
    date: t,
    name: P(t, "EEE", e ? { locale: e } : void 0),
    dateString: P(xe(t, 12), X.fullDate),
    weekNumber: ne(t, { locale: e }),
    year: wt(t),
    month: tt(t),
    dayOfMonth: Ct(t),
    dayOfWeek: n,
    isFirstDayOfWeek: n === 1,
    isLastDayOfWeek: n === 7,
    isFirstDayOfMonth: j(te(t), t),
    isLastDayOfMonth: j(Vt(t), t)
  };
}, Qe = (t, e) => $t({
  start: t,
  end: G(t, 6)
}).map((n) => qe(n, e)), Xe = (t, e) => e > 11 ? { year: t + Math.floor(e / 12), month: e % 12 } : e < 0 ? { year: t + Math.floor(e / 12), month: 12 + e % 12 } : { year: t, month: e }, Ze = "_calendar_1w0de_1", Fe = {
  calendar: Ze
}, ve = (t, e, n) => !!(e && e.indexOf(n) >= 0 || t && t.highlights && t.highlights.indexOf(n) >= 0), V = (t, e, n, r, s) => {
  if (n.length !== r.length)
    throw new Error(
      "Select highlight failed, number of values do not equal number of highlights."
    );
  if (n.length === 0)
    return s;
  for (let i = 0; i < n.length; i++)
    if (typeof n[i] == "boolean" && n[i] || typeof n[i] == "string" && ve(
      t,
      e,
      n[i]
    ))
      return r[i];
  return s;
}, Ve = ({
  selectedBackground: t,
  todayBackground: e,
  rangeBackground: n,
  borderColor: r = "transparent"
}) => (s, i, d, o, l) => {
  let a = {};
  const f = V(
    i,
    s,
    ["selected", "range", "today", d.month === l.monthInYear],
    [t, n, e, "#fff"],
    "transparent"
  );
  return {
    ...a,
    backgroundColor: f,
    borderTopLeftRadius: V(
      i,
      s,
      ["selectedStart", "singleSelected"],
      [
        "var(--swui-calendar-day-border-radius)",
        "var(--swui-calendar-day-border-radius)"
      ],
      r
    ),
    borderBottomLeftRadius: V(
      i,
      s,
      ["selectedStart", "singleSelected"],
      [
        "var(--swui-calendar-day-border-radius)",
        "var(--swui-calendar-day-border-radius)"
      ],
      r
    ),
    borderTopRightRadius: V(
      i,
      s,
      ["selectedEnd", "singleSelected"],
      [
        "var(--swui-calendar-day-border-radius)",
        "var(--swui-calendar-day-border-radius)"
      ],
      r
    ),
    borderBottomRightRadius: V(
      i,
      s,
      ["selectedEnd", "singleSelected"],
      [
        "var(--swui-calendar-day-border-radius)",
        "var(--swui-calendar-day-border-radius)"
      ],
      r
    ),
    boxSizing: "border-box"
  };
}, tn = ({
  selectedColor: t,
  disabledColor: e,
  inOtherMonthColor: n,
  rangeTextColor: r
}) => (s, i, d, o, l) => {
  const a = d.month !== l.monthInYear;
  return {
    color: V(
      i,
      s,
      [a, "selected", "range", "enabled", "disabled"],
      [
        n,
        t,
        r,
        void 0,
        e
      ]
    )
  };
}, rt = {
  width: "var(--swui-calendar-day-width)",
  height: "var(--swui-calendar-day-height)",
  WeekNumber: {
    backgroundColor: "var(--swui-calendar-week-number-bg-color)",
    textColor: "var(--swui-calendar-week-number-text-color)",
    clickableTextColor: "var(--swui-calendar-week-number-clickable-text-color)",
    show: !0
  },
  WeekDay: {
    textColor: "var(--swui-calendar-week-day-text-color)",
    clickableTextColor: "var(--swui-calendar-week-day-clickable-text-color)"
  },
  CalendarDay: {
    tdStyle: Ve({
      selectedBackground: "var(--swui-calendar-wrapper-selected-background)",
      rangeBackground: "var(--swui-calendar-wrapper-range-background)",
      todayBackground: "var(--swui-calendar-wrapper-today-background)"
    }),
    textProps: tn({
      selectedColor: "var(--swui-calendar-text-selected-color)",
      disabledColor: "var(--swui-calendar-text-disabled-color)",
      inOtherMonthColor: "var(--swui-calendar-text-in-other-month-color)"
    })
  },
  CalendarMonth: {
    headerTextColor: "var(--swui-calendar-week-day-text-color)"
  }
}, gr = {
  ...rt,
  width: "37px",
  height: "37px"
}, en = (t, e, n) => e && Ce(t, e) ? j(t, e) : n && et(t, n) ? j(t, n) : !0, nn = function({
  dayComponent: e,
  minDate: n,
  maxDate: r,
  dayState: s,
  day: i,
  ...d
}) {
  const o = x(
    () => en(i.date, n, r) ? s : oe(s, ["disabled"]),
    [i.date, s, r, n]
  );
  return /* @__PURE__ */ c(e, { day: i, ...d, dayState: o });
}, rn = ({
  onClickWeek: t,
  theme: e,
  week: n,
  background: r,
  backgroundColor: s,
  prefix: i
}) => {
  const d = /* @__PURE__ */ R(
    N,
    {
      width: e.width,
      height: e.height,
      justifyContent: "center",
      alignItems: "center",
      children: [
        r && /* @__PURE__ */ c(N, { position: "absolute", children: r }),
        /* @__PURE__ */ c(N, { position: "absolute", children: /* @__PURE__ */ R(
          ct,
          {
            color: t ? e.WeekNumber.clickableTextColor : e.WeekNumber.textColor,
            children: [
              i,
              n.weekNumber
            ]
          }
        ) })
      ]
    }
  );
  return /* @__PURE__ */ c(
    N,
    {
      background: s || e.WeekNumber.backgroundColor,
      position: "relative",
      children: t ? /* @__PURE__ */ c(
        Ut,
        {
          borderRadius: "var(--swui-calendar-day-border-radius)",
          onClick: (o) => t(n, o),
          disableFocusHighlight: !t,
          children: d
        }
      ) : d
    }
  );
};
function sn({
  week: t,
  month: e,
  dayComponent: n,
  statePerWeekDay: r,
  userDataPerWeekDay: s,
  minDate: i,
  maxDate: d,
  onClickWeek: o,
  onClickDay: l,
  theme: a,
  renderWeekNumber: f,
  extraDayContent: D,
  defaultHighlights: u
}) {
  return /* @__PURE__ */ R("tr", { children: [
    a.WeekNumber.show && /* @__PURE__ */ c("td", { children: f ? f(t, a, o) : /* @__PURE__ */ c(
      rn,
      {
        week: t,
        onClickWeek: o,
        theme: a
      }
    ) }),
    t.days.map((h) => /* @__PURE__ */ c(
      nn,
      {
        dayComponent: n,
        day: h,
        week: t,
        month: e,
        dayState: r && r[h.dayOfMonth],
        userData: s && s[h.dayOfMonth],
        onClickDay: l,
        theme: a,
        extraDayContent: D,
        defaultHighlights: u,
        minDate: i,
        maxDate: d
      },
      h.dateString
    ))
  ] }, t.weekNumber);
}
const cn = ({
  onClickWeekDay: t,
  day: e,
  theme: n
}) => {
  const r = /* @__PURE__ */ c(
    N,
    {
      width: n.width,
      height: n.height,
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ c(
        ct,
        {
          size: "small",
          color: t ? n.WeekDay.clickableTextColor : n.WeekDay.textColor,
          children: e.name
        }
      )
    }
  );
  return t ? /* @__PURE__ */ c(
    Ut,
    {
      borderRadius: "var(--swui-calendar-day-border-radius)",
      onClick: (s) => t(e.dayOfWeek, s),
      disableFocusHighlight: !t,
      children: r
    }
  ) : r;
}, le = function({
  day: e,
  week: n,
  month: r,
  dayState: s,
  userData: i,
  onClickDay: d,
  theme: o,
  extraDayContent: l,
  defaultHighlights: a
}) {
  const f = /* @__PURE__ */ c(
    N,
    {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ c(
        ct,
        {
          ...o.CalendarDay.textProps && o.CalendarDay.textProps(
            a,
            s,
            e,
            n,
            r,
            i
          ),
          children: e.dayOfMonth
        }
      )
    }
  ), D = It.td({
    ...o.CalendarDay.tdStyle && o.CalendarDay.tdStyle(
      a,
      s,
      e,
      n,
      r,
      i
    )
  }), u = It.div({
    ...o.CalendarDay.innerWrapperStyle && o.CalendarDay.innerWrapperStyle(
      a,
      s,
      e,
      n,
      r,
      i
    ),
    width: "100%",
    height: "100%"
  }), h = It.div({
    ...o.CalendarDay.cellWrapperStyle && o.CalendarDay.cellWrapperStyle(
      a,
      s,
      e,
      n,
      r,
      i
    ),
    width: "100%",
    height: "100%",
    position: "relative"
  });
  return /* @__PURE__ */ c(D, { children: /* @__PURE__ */ c(u, { children: /* @__PURE__ */ c(h, { children: e.month === r.monthInYear && /* @__PURE__ */ R(Dt, { children: [
    l && /* @__PURE__ */ c(
      l,
      {
        week: n,
        month: r,
        day: e,
        dayState: s,
        theme: o,
        userData: i
      }
    ),
    d && on(a, s) ? /* @__PURE__ */ c(
      Ut,
      {
        onClick: (w) => d(e, i, w),
        style: { width: "100%", height: "100%" },
        borderRadius: "var(--swui-calendar-day-border-radius)",
        children: f
      }
    ) : /* @__PURE__ */ c(Dt, { children: f })
  ] }) }) }) });
}, on = (t, e) => !!V(
  e,
  t,
  ["enabled", "disabled"],
  [!0, !1],
  !0
);
function dn({
  month: t,
  dayComponent: e = le,
  statePerWeek: n,
  userDataPerWeek: r,
  minDate: s,
  maxDate: i,
  onClickDay: d,
  onClickWeek: o,
  onClickWeekDay: l,
  onClickMonth: a,
  onClickYear: f,
  renderWeekNumber: D,
  renderWeekDay: u,
  headerLeftContent: h,
  headerRightContent: w,
  theme: k = rt,
  extraDayContent: p,
  defaultHighlights: b
}) {
  const y = k.WeekNumber.show;
  return /* @__PURE__ */ c(Dt, { children: /* @__PURE__ */ R(N, { alignItems: "stretch", children: [
    /* @__PURE__ */ R(
      E,
      {
        justifyContent: "space-between",
        alignItems: "center",
        height: "32px",
        children: [
          /* @__PURE__ */ c(N, { alignItems: "center", children: h }),
          /* @__PURE__ */ R(E, { alignItems: "center", children: [
            /* @__PURE__ */ c(E, { width: "104px", justifyContent: "center", children: a ? /* @__PURE__ */ c(
              A,
              {
                onClick: () => a(t),
                label: t.name
              }
            ) : /* @__PURE__ */ c(ct, { children: t.name }) }),
            /* @__PURE__ */ c(W, {}),
            /* @__PURE__ */ c(E, { width: "64px", justifyContent: "center", children: f ? /* @__PURE__ */ c(
              A,
              {
                onClick: () => f(t.year),
                label: String(t.year)
              }
            ) : /* @__PURE__ */ c(ct, { children: t.year }) })
          ] }),
          /* @__PURE__ */ c(N, { alignItems: "center", children: w })
        ]
      }
    ),
    /* @__PURE__ */ c("table", { children: /* @__PURE__ */ R("tbody", { children: [
      /* @__PURE__ */ R("tr", { children: [
        y && /* @__PURE__ */ c("td", { children: /* @__PURE__ */ c(N, { width: k.width, height: k.height }) }),
        t.weeks[0].days.map((m) => /* @__PURE__ */ c("td", { children: u ? u(m.name, k, l) : /* @__PURE__ */ c(
          cn,
          {
            day: m,
            onClickWeekDay: l,
            theme: k
          }
        ) }, m.name))
      ] }),
      t.weeks.map((m) => /* @__PURE__ */ c(
        sn,
        {
          month: t,
          week: m,
          dayComponent: e,
          statePerWeekDay: n && n[m.weekNumber],
          userDataPerWeekDay: r && r[m.weekNumber],
          onClickDay: d,
          onClickWeek: o,
          theme: k,
          renderWeekNumber: D,
          extraDayContent: p,
          defaultHighlights: b,
          minDate: s,
          maxDate: i
        },
        m.weekNumber
      ))
    ] }) })
  ] }) });
}
function ln({
  monthRows: t,
  dayComponent: e = le,
  userDataPerMonth: n,
  statePerMonth: r,
  minDate: s,
  maxDate: i,
  onClickDay: d,
  onClickWeekDay: o,
  onClickWeek: l,
  onClickMonth: a,
  onClickYear: f,
  renderWeekDay: D,
  renderWeekNumber: u,
  headerLeftContent: h,
  headerRightContent: w,
  extraDayContent: k,
  defaultHighlights: p,
  theme: b = rt
}) {
  const y = x(
    () => s ? ot(s, "yyyy-MM-dd", /* @__PURE__ */ new Date()) : void 0,
    [s]
  ), m = x(
    () => i ? ot(i, "yyyy-MM-dd", /* @__PURE__ */ new Date()) : void 0,
    [i]
  );
  return /* @__PURE__ */ c("div", { className: Fe.calendar, children: t.map((M, C) => /* @__PURE__ */ c(ye, { children: /* @__PURE__ */ c(E, { children: M.map((T, I) => /* @__PURE__ */ R(ie.Fragment, { children: [
    I > 0 && /* @__PURE__ */ c(W, {}),
    /* @__PURE__ */ c(
      dn,
      {
        month: T,
        dayComponent: e,
        userDataPerWeek: n && n[T.monthString],
        statePerWeek: r && r[T.monthString],
        onClickDay: d,
        onClickWeekDay: o,
        onClickWeek: l,
        onClickMonth: a,
        onClickYear: f,
        theme: b,
        renderWeekNumber: u,
        renderWeekDay: D,
        headerLeftContent: h,
        headerRightContent: w,
        extraDayContent: k,
        defaultHighlights: p,
        minDate: y,
        maxDate: m
      }
    )
  ] }, T.name)) }) }, C)) });
}
function Lt(t) {
  const e = an(t.year, t.month, t.date), { year: n, month: r } = Xe(
    e.year,
    e.month
  ), s = fn(
    n,
    r,
    t.locale ?? jt,
    t.numMonths,
    t.monthsPerRow
  ), i = Je(
    t.highlightToday,
    t.statePerMonth
  );
  return /* @__PURE__ */ c(
    ln,
    {
      year: n,
      month: r,
      monthRows: s,
      ...t,
      statePerMonth: i
    }
  );
}
const an = (t, e, n) => {
  if (e && t)
    return {
      month: e,
      year: t
    };
  if (n)
    return {
      month: tt(n),
      year: wt(n)
    };
  const r = /* @__PURE__ */ new Date();
  return {
    month: tt(r),
    year: wt(r)
  };
}, fn = (t, e, n, r, s) => r == null ? [[de(t, e, n)]] : s == null ? [Kt(t, e, r, n)] : se(Kt(t, e, r, n), s), un = ({
  value: t,
  onValueChange: e,
  month: n,
  locale: r
}) => {
  const s = x(() => {
    const i = new Date(2e3, n, 1);
    return re(P(i, "MMM", { locale: r }));
  }, [r, n]);
  return /* @__PURE__ */ c(E, { justifyContent: "center", children: t === n ? /* @__PURE__ */ c(
    dt,
    {
      label: s,
      onClick: () => e && e(n)
    }
  ) : /* @__PURE__ */ c(
    A,
    {
      label: s,
      onClick: () => e && e(n)
    }
  ) });
}, hn = [
  [L.JANUARY, L.FEBRUARY, L.MARCH],
  [L.APRIL, L.MAY, L.JUNE],
  [L.JULY, L.AUGUST, L.SEPTEMBER],
  [L.OCTOBER, L.NOVEMBER, L.DECEMBER]
], Dn = ({
  value: t,
  onValueChange: e,
  locale: n = jt
}) => /* @__PURE__ */ c(B, { gap: 1, children: hn.map((r) => /* @__PURE__ */ c(E, { gap: 1, children: r.map((s) => /* @__PURE__ */ c(
  un,
  {
    month: s,
    onValueChange: e,
    value: t,
    locale: n
  },
  s
)) }, r[0])) }), gn = (t) => [
  {
    label: "Past",
    presets: [
      { label: "Last 3 days", startDate: t, endDate: ht(t, 2) },
      { label: "Last 7 days", startDate: t, endDate: ht(t, 6) },
      { label: "Last 30 days", startDate: t, endDate: ht(t, 29) },
      { label: "Last 45 days", startDate: t, endDate: ht(t, 44) }
    ]
  },
  {
    label: "Future",
    presets: [
      { label: "Next 3 days", startDate: t, endDate: G(t, 2) },
      { label: "Next 7 days", startDate: t, endDate: G(t, 6) },
      { label: "Next 30 days", startDate: t, endDate: G(t, 29) },
      { label: "Next 45 days", startDate: t, endDate: G(t, 44) }
    ]
  }
], mn = ({
  onClickPreset: t
}) => {
  const [e, n] = S(0), r = x(() => gn(/* @__PURE__ */ new Date()), []), s = r[e] ?? r[0];
  return /* @__PURE__ */ R(B, { children: [
    /* @__PURE__ */ R(
      E,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "200px",
        children: [
          /* @__PURE__ */ c(
            A,
            {
              size: "small",
              leftIcon: Wt,
              disabled: e === 0,
              onClick: () => n(e - 1)
            }
          ),
          /* @__PURE__ */ c(ct, { children: s.label }),
          /* @__PURE__ */ c(
            A,
            {
              size: "small",
              leftIcon: Ot,
              disabled: e === r.length - 1,
              onClick: () => n(e + 1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ c(W, {}),
    /* @__PURE__ */ c(B, { alignItems: "center", children: s.presets.map((i) => /* @__PURE__ */ R(ie.Fragment, { children: [
      /* @__PURE__ */ c(
        dt,
        {
          label: i.label,
          onClick: () => t(i)
        }
      ),
      /* @__PURE__ */ c(W, {})
    ] }, i.label)) })
  ] });
}, wn = ({
  value: t,
  onValueChange: e,
  year: n
}) => {
  const r = String(n);
  return /* @__PURE__ */ c(E, { justifyContent: "center", children: t === n ? /* @__PURE__ */ c(dt, { label: r, onClick: () => e == null ? void 0 : e(n) }) : /* @__PURE__ */ c(A, { label: r, onClick: () => e == null ? void 0 : e(n) }) });
}, yn = ({
  value: t,
  onValueChange: e,
  initialLastYear: n
}) => {
  const [r, s] = S(() => t ? t + 4 : n ?? (/* @__PURE__ */ new Date()).getFullYear() + 4), i = x(() => {
    const d = r - 11;
    return se(zt(d, r + 1), 3);
  }, [r]);
  return q(() => {
    s((d) => pn(t, d));
  }, [t]), /* @__PURE__ */ R(E, { children: [
    /* @__PURE__ */ c(B, { justifyContent: "center", children: /* @__PURE__ */ c(
      A,
      {
        leftIcon: be,
        onClick: () => s(r - 3)
      }
    ) }),
    /* @__PURE__ */ c(B, { gap: 1, children: i.map((d) => /* @__PURE__ */ c(E, { gap: 1, children: d.map((o) => /* @__PURE__ */ c(
      wn,
      {
        year: o,
        onValueChange: e,
        value: t
      },
      o
    )) }, d[0])) }),
    /* @__PURE__ */ c(B, { justifyContent: "center", children: /* @__PURE__ */ c(
      A,
      {
        leftIcon: Qt,
        onClick: () => s(r + 3)
      }
    ) })
  ] });
}, pn = (t, e) => {
  if (t == null)
    return e;
  if (t > e) {
    const r = t - e, s = r % 3, i = r - s + 3;
    return e + i;
  }
  const n = e - 11;
  if (t < n) {
    const r = n - t, s = r % 3, i = r - s + 3;
    return e - i;
  }
  return e;
}, bn = function({
  locale: e,
  dateInFocus: n,
  setDateInFocus: r,
  currentPanel: s,
  setCurrentPanel: i,
  ...d
}) {
  const o = g(
    (D) => {
      const u = n ? new Date(n) : /* @__PURE__ */ new Date();
      u.setMonth(D), r && r(u), i("calendar");
    },
    [n, r, i]
  ), l = g(
    (D) => {
      const u = n ? new Date(n) : /* @__PURE__ */ new Date();
      u.setFullYear(D), r && r(u), i("calendar");
    },
    [n, r, i]
  ), a = g(() => {
    i("year");
  }, [i]), f = g(() => {
    i("month");
  }, [i]);
  switch (s) {
    case "calendar":
      return /* @__PURE__ */ c(Dt, { children: /* @__PURE__ */ c(
        Lt,
        {
          ...d,
          date: n,
          onClickYear: a,
          onClickMonth: f,
          locale: e
        }
      ) });
    case "month":
      return /* @__PURE__ */ c(
        Dn,
        {
          value: n.getMonth(),
          onValueChange: o,
          locale: e
        }
      );
    case "year":
      return /* @__PURE__ */ c(
        yn,
        {
          value: n.getFullYear(),
          onValueChange: l
        }
      );
    case "presets":
      return /* @__PURE__ */ c(mn, { onClickPreset: () => {
      } });
    default:
      return /* @__PURE__ */ c(N, { children: /* @__PURE__ */ c(
        dt,
        {
          label: "Show calendar",
          onClick: () => i("calendar")
        }
      ) });
  }
}, kn = (t, e, n, r) => {
  const s = g(() => {
    const l = Ie(t, n ?? r ?? 1);
    e == null || e(l);
  }, [e, t, n, r]), i = g(() => {
    const l = Ne(t, 1);
    e == null || e(l);
  }, [e, t]), d = g(() => {
    const l = Ye(t, n ?? r ?? 1);
    e == null || e(l);
  }, [e, t, n, r]), o = g(() => {
    const l = He(t, 1);
    e == null || e(l);
  }, [e, t]);
  return {
    nextMonth: s,
    prevMonth: d,
    nextYear: i,
    prevYear: o
  };
}, Sn = ({
  children: t,
  prevMonth: e,
  nextMonth: n,
  prevYear: r,
  nextYear: s
}) => /* @__PURE__ */ R("div", { children: [
  t,
  /* @__PURE__ */ c(gt, { children: /* @__PURE__ */ R(E, { children: [
    /* @__PURE__ */ c(A, { onClick: r, leftIcon: Xt }),
    /* @__PURE__ */ c(W, {}),
    /* @__PURE__ */ c(A, { onClick: e, leftIcon: Wt }),
    /* @__PURE__ */ c(gt, { num: 2 }),
    /* @__PURE__ */ c(A, { onClick: n, leftIcon: Ot }),
    /* @__PURE__ */ c(W, {}),
    /* @__PURE__ */ c(A, { onClick: s, leftIcon: Zt })
  ] }) }),
  /* @__PURE__ */ c(W, {})
] }), Mn = () => {
};
function Z({
  monthSwitcherPlacement: t,
  theme: e = rt,
  dateInFocus: n,
  setDateInFocus: r,
  currentPanel: s,
  setCurrentPanel: i,
  onSelectPreset: d = Mn,
  hideYearPagination: o = !1,
  ...l
}) {
  const { nextMonth: a, prevMonth: f, nextYear: D, prevYear: u } = kn(
    n,
    r,
    l.monthsPerRow,
    l.numMonths
  );
  switch (Rn(
    t,
    l.numMonths
  )) {
    case "below":
      return /* @__PURE__ */ c(
        Sn,
        {
          theme: e,
          nextMonth: a,
          prevMonth: f,
          nextYear: D,
          prevYear: u,
          children: /* @__PURE__ */ c(Lt, { ...l, theme: e, date: n })
        }
      );
    case "header":
      return /* @__PURE__ */ c(B, { children: /* @__PURE__ */ c(
        bn,
        {
          ...l,
          theme: e,
          dateInFocus: n,
          setDateInFocus: r,
          currentPanel: s,
          setCurrentPanel: i,
          onSelectPreset: d,
          headerLeftContent: /* @__PURE__ */ R(E, { alignItems: "center", children: [
            !o && /* @__PURE__ */ c(
              A,
              {
                onClick: u,
                leftIcon: Xt
              }
            ),
            /* @__PURE__ */ c(W, {}),
            /* @__PURE__ */ c(A, { onClick: f, leftIcon: Wt })
          ] }),
          headerRightContent: /* @__PURE__ */ R(E, { alignItems: "center", children: [
            /* @__PURE__ */ c(A, { onClick: a, leftIcon: Ot }),
            /* @__PURE__ */ c(W, {}),
            !o && /* @__PURE__ */ c(
              A,
              {
                onClick: D,
                leftIcon: Zt
              }
            )
          ] })
        }
      ) });
    default:
      return /* @__PURE__ */ c(Lt, { ...l, theme: e, date: n });
  }
}
const Rn = (t, e) => t || (e || 1) > 1 ? "below" : "header", En = (t) => ({
  startDate: t.startDate ? P(t.startDate, "yyyy-MM-dd") : void 0,
  endDate: t.endDate ? P(t.endDate, "yyyy-MM-dd") : void 0
}), Tn = ({
  startDate: t,
  endDate: e
}) => {
  const n = /* @__PURE__ */ new Date();
  return {
    startDate: t ? ot(t, "yyyy-MM-dd", n) : void 0,
    endDate: e ? ot(e, "yyyy-MM-dd", n) : void 0
  };
}, ae = ({
  startDate: t,
  endDate: e
}) => !!(t && e && !j(t, e) && et(t, e)), fe = (t) => ae(t) ? {
  startDate: t.endDate,
  endDate: t.startDate
} : t, mr = (t) => t.startDate && t.endDate ? En(
  fe(Tn(t))
) : t, ue = (t, e, n, r) => g(
  (s) => {
    const i = {
      startDate: n === "startDate" ? s.date : t == null ? void 0 : t.startDate,
      endDate: n === "endDate" ? s.date : t == null ? void 0 : t.endDate
    };
    ae(i) || r(n === "startDate" ? "endDate" : "startDate"), e == null || e(fe(i));
  },
  [
    n,
    e,
    r,
    t == null ? void 0 : t.endDate,
    t == null ? void 0 : t.startDate
  ]
), bt = (t) => {
  const [e, n] = S("calendar"), r = g(
    (s) => {
      n(s), t == null || t(s);
    },
    [t]
  );
  return {
    currentPanel: e,
    setCurrentPanel: r
  };
}, An = ({
  focusedInput: t,
  value: e,
  onValueChange: n,
  setFocusedInput: r,
  statePerMonth: s,
  onChangePanel: i,
  initialDateInFocus: d
}) => {
  const { currentPanel: o, setCurrentPanel: l } = bt(i), [a, f] = S(
    () => d ?? /* @__PURE__ */ new Date()
  ), D = ue(
    e,
    n,
    t,
    r
  ), u = x(
    () => yt(
      s,
      e == null ? void 0 : e.startDate,
      e == null ? void 0 : e.endDate
    ),
    [s, e == null ? void 0 : e.endDate, e == null ? void 0 : e.startDate]
  );
  return {
    onClickDay: D,
    statePerMonth: u,
    currentPanel: o,
    setCurrentPanel: l,
    setDateInFocus: f,
    dateInFocus: a
  };
};
function wr(t) {
  const e = An(t);
  return /* @__PURE__ */ c(Z, { ...t, ...e });
}
const yr = () => {
  const [t, e] = S(), [n, r] = S(), [s, i] = S("startDate");
  return {
    startDate: t,
    setStartDate: e,
    endDate: n,
    setEndDate: r,
    focusedInput: s,
    setFocusedInput: i
  };
}, xn = ({
  onChange: t,
  value: e,
  statePerMonth: n,
  onChangePanel: r
}) => {
  const { currentPanel: s, setCurrentPanel: i } = bt(r), [d, o] = S(() => e ?? /* @__PURE__ */ new Date()), l = g(
    (f) => {
      t && t(f.date);
    },
    [t]
  ), a = x(
    () => e ? Q(n, e, [
      "selected",
      "singleSelected"
    ]) : n,
    [n, e]
  );
  return {
    onClickDay: l,
    statePerMonth: a,
    date: e,
    currentPanel: s,
    setCurrentPanel: i,
    dateInFocus: d,
    setDateInFocus: o
  };
};
function he(t) {
  const e = xn(t);
  return /* @__PURE__ */ c(Z, { ...t, ...e });
}
const Cn = ({
  onChange: t,
  value: e,
  statePerMonth: n,
  onChangePanel: r
}) => {
  const { currentPanel: s, setCurrentPanel: i } = bt(r), [d, o] = S(() => /* @__PURE__ */ new Date()), l = g(
    (f) => {
      if (!t)
        return;
      const D = e && e.find((u) => j(u, f.date));
      t(e && D ? e.filter((u) => !j(u, f.date)) : [...e || [], f.date]);
    },
    [t, e]
  ), a = x(() => e ? e.reduce(
    (f, D) => Q(f, D, ["selected"]),
    n
  ) : n, [n, e]);
  return {
    onClickDay: l,
    statePerMonth: a,
    currentPanel: s,
    setCurrentPanel: i,
    dateInFocus: d,
    setDateInFocus: o
  };
};
function pr(t) {
  const e = Cn(t);
  return /* @__PURE__ */ c(Z, { ...t, ...e });
}
const In = ({
  onChange: t,
  value: e,
  statePerMonth: n,
  onChangePanel: r,
  locale: s = jt
}) => {
  const [i, d] = S(() => {
    const h = Nt(e, s);
    return h ? h.days[0].date : /* @__PURE__ */ new Date();
  }), { currentPanel: o, setCurrentPanel: l } = bt(r), a = g(
    (h) => {
      t && t(Gt(_t(h.date, s)));
    },
    [s, t]
  ), f = g(
    (h) => {
      t && t(Gt(h));
    },
    [t]
  ), D = x(() => {
    const h = Nt(e, s);
    return h ? _e(n, h) : n;
  }, [e, s, n]), u = x(() => {
    const h = Nt(e, s);
    return h ? h.days[0].date : /* @__PURE__ */ new Date();
  }, [s, e]);
  return {
    statePerMonth: D,
    date: u,
    dateInFocus: i,
    setDateInFocus: d,
    onClickDay: a,
    onClickWeek: f,
    currentPanel: o,
    setCurrentPanel: l
  };
}, Gt = (t) => {
  if (t)
    return `${t.endYear}-${t.weekNumber}`;
}, Nt = (t, e) => {
  if (!t)
    return;
  const n = t.split("-"), r = parseInt(n[1], 10), s = parseInt(n[0], 10), i = /* @__PURE__ */ new Date();
  i.setFullYear(s);
  const d = ee(Le(i, r), { locale: e });
  return _t(d, e);
};
function br(t) {
  const e = In(t);
  return /* @__PURE__ */ c(Z, { ...t, ...e });
}
const Nn = (t, e) => t.filter((n) => !j(n, e)), Yn = (t, e) => !!t.find((n) => j(n, e)), Hn = ({
  value: t,
  onValueChange: e,
  statePerMonth: n,
  onChangePanel: r
}) => {
  const [s, i] = S(), [d, o] = S("startDate"), { currentPanel: l, setCurrentPanel: a } = bt(r), [f, D] = S(
    () => (d && (t == null ? void 0 : t[d])) ?? /* @__PURE__ */ new Date()
  ), u = g(
    (p) => {
      i(p);
      const { startDate: b, endDate: y } = p;
      if (e)
        if (b && y) {
          const m = $t({ start: b, end: y });
          e(m);
        } else
          b ? e([b]) : y && e([y]);
    },
    [e]
  ), h = ue(
    s,
    u,
    d,
    o
  ), w = g(
    (p, b, y) => {
      e && (y.ctrlKey || y.metaKey ? t ? Yn(t, p.date) ? e(Nn(t, p.date)) : e([...t, p.date]) : e([p.date]) : h(p, b, y));
    },
    [e, h, t]
  ), k = x(() => Ln(n, t), [n, t]);
  return {
    onClickDay: w,
    statePerMonth: k,
    currentPanel: l,
    setCurrentPanel: a,
    dateInFocus: f,
    setDateInFocus: D
  };
}, Ln = (t, e) => e ? e.reduce((n, r) => Q(n, r, ["selected"]), t) : t;
function kr(t) {
  const e = Hn(t);
  return /* @__PURE__ */ c(Z, { ...t, ...e });
}
const kt = "bottom", De = () => {
  const [t, e] = Be();
  return {
    onChangePanel: g(() => {
      var r, s;
      (s = (r = e.current) == null ? void 0 : r.popperInstance) == null || s.update();
    }, [e]),
    tippyRef: t
  };
}, Pn = (t, e, n) => {
  const [r, s] = S(n || !1), i = g(() => (s(!0), !0), [s]), d = g(() => {
    s(!1), e && e();
  }, [s, e]), o = g(
    (l) => {
      t && t(l), setTimeout(d, 150);
    },
    [t, d]
  );
  return {
    showCalendar: i,
    hideCalendar: d,
    showingCalendar: r,
    onSelectDate: o
  };
}, St = "2999-12-31", Sr = ({
  displayFormat: t = X.fullDate,
  placeholder: e = "Enter date",
  value: n,
  zIndex: r = 100,
  calendarTheme: s = rt,
  calendarProps: i,
  openOnMount: d,
  onClose: o,
  onChange: l,
  portalTarget: a,
  variant: f,
  width: D,
  minDate: u,
  maxDate: h = St,
  disabled: w
}) => {
  const { hideCalendar: k, showingCalendar: p, onSelectDate: b, showCalendar: y } = Pn(l, o, d), { tippyRef: m, onChangePanel: M } = De();
  return /* @__PURE__ */ c(N, { width: D, children: /* @__PURE__ */ c(
    pt,
    {
      arrow: !1,
      lazy: !0,
      visible: p,
      onClickOutside: k,
      placement: kt,
      zIndex: r,
      appendTo: a ?? "parent",
      tippyRef: m,
      disabled: w,
      content: /* @__PURE__ */ c(
        he,
        {
          ...i,
          onChange: b,
          value: n,
          theme: s,
          onChangePanel: M,
          minDate: u,
          maxDate: h
        }
      ),
      children: /* @__PURE__ */ c(
        nt,
        {
          type: "date",
          onFocus: y,
          buttonRight: /* @__PURE__ */ c(ke, { onClick: y, icon: mt }),
          value: n ? P(n, t) : "",
          placeholder: e,
          size: 9,
          disabled: w,
          autoFocus: d,
          variant: f,
          min: u,
          max: h
        }
      )
    }
  ) });
}, Un = (t, e) => {
  const n = _(null), r = _(null), [s, i] = S(!1), [d, o] = S(void 0), l = g(() => (o("startDate"), i(!0), !0), [o, i]), a = g(() => (o("endDate"), i(!0), !0), [o, i]), f = g(() => {
    i(!1);
  }, [i]), D = g(
    (h) => {
      d === "startDate" ? (e == null || e({
        startDate: h.date,
        endDate: t == null ? void 0 : t.endDate
      }), t != null && t.endDate ? setTimeout(f, 150) : (o("endDate"), r.current && r.current.focus())) : d === "endDate" && (e == null || e({
        startDate: t == null ? void 0 : t.startDate,
        endDate: h.date
      }), t != null && t.startDate ? setTimeout(f, 150) : (o("startDate"), n.current && n.current.focus()));
    },
    [d, e, o, f, t]
  ), u = x(
    () => (t == null ? void 0 : t.startDate) && (t == null ? void 0 : t.endDate) && et(t.startDate, t.endDate),
    [t == null ? void 0 : t.startDate, t == null ? void 0 : t.endDate]
  );
  return {
    showingCalendar: s,
    hideCalendar: f,
    showCalendarEndDate: a,
    showCalendarStartDate: l,
    focusedInput: d,
    setFocusedInput: o,
    startDateInputRef: n,
    endDateInputRef: r,
    onClickDay: D,
    startDateIsAfterEnd: u
  };
};
function Mr({
  displayFormat: t = X.fullDate,
  placeholderStartDate: e = "Start date",
  placeholderEndDate: n = "End date",
  portalTarget: r,
  value: s,
  onValueChange: i,
  zIndex: d = 100,
  width: o,
  calendarTheme: l = rt,
  calendarProps: a,
  minDate: f,
  maxDate: D = St,
  disabled: u
}) {
  const [h, w] = S("calendar"), {
    hideCalendar: k,
    showCalendarEndDate: p,
    showCalendarStartDate: b,
    showingCalendar: y,
    focusedInput: m,
    startDateInputRef: M,
    endDateInputRef: C,
    onClickDay: T,
    startDateIsAfterEnd: I
  } = Un(s, i), [U, Y] = S(
    () => (m && (s == null ? void 0 : s[m])) ?? /* @__PURE__ */ new Date()
  ), z = x(
    () => yt(void 0, s == null ? void 0 : s.startDate, s == null ? void 0 : s.endDate),
    [s]
  );
  return /* @__PURE__ */ c(
    pt,
    {
      arrow: !1,
      lazy: !0,
      disabled: u,
      visible: y,
      zIndex: d,
      placement: kt,
      appendTo: r ?? "parent",
      onClickOutside: k,
      content: /* @__PURE__ */ c(
        Z,
        {
          ...a,
          dateInFocus: U,
          setDateInFocus: Y,
          statePerMonth: z,
          theme: l,
          onClickDay: T,
          currentPanel: h,
          setCurrentPanel: w,
          minDate: f,
          maxDate: D
        }
      ),
      children: /* @__PURE__ */ R(E, { alignItems: "center", children: [
        /* @__PURE__ */ c(
          nt,
          {
            iconLeft: mt,
            onFocus: b,
            value: s != null && s.startDate ? P(s.startDate, t) : "",
            placeholder: e,
            width: o,
            disabled: u,
            inputRef: M,
            size: 9,
            variant: I ? "error" : void 0
          }
        ),
        /* @__PURE__ */ c(W, {}),
        /* @__PURE__ */ c(
          Ft,
          {
            icon: Se,
            color: ce("--lhds-color-ui-500"),
            size: 14
          }
        ),
        /* @__PURE__ */ c(W, {}),
        /* @__PURE__ */ c(
          nt,
          {
            iconLeft: mt,
            onFocus: p,
            value: s != null && s.endDate ? P(s.endDate, t) : "",
            placeholder: n,
            width: o,
            disabled: u,
            inputRef: C,
            size: 9,
            variant: I ? "error" : void 0
          }
        )
      ] })
    }
  );
}
const Rr = ({
  calendarProps: t,
  closeOnCalendarSelectDate: e = !0,
  dateFormat: n = X.fullDate,
  disableCalender: r = !1,
  onValueChange: s,
  placeholder: i = "yyyy-mm-dd",
  portalTarget: d,
  value: o,
  width: l = "130px",
  zIndex: a = 100,
  calendarTheme: f = rt,
  hideCalenderIcon: D = !1,
  minDate: u,
  maxDate: h = St,
  variant: w,
  ...k
}) => {
  const [p, b] = S(!1), { tippyRef: y, onChangePanel: m } = De(), M = g(() => {
    b(!p);
  }, [b, p]), C = g(() => {
    b(!1);
  }, [b]), T = g(
    (O) => {
      s && s(O);
    },
    [s]
  ), I = g(
    (O) => {
      O && (T(P(O, n)), e && setTimeout(() => b(!p), 200));
    },
    [T, n, e, b, p]
  ), U = !!o && !/^[-/\\.0-9]+$/.test(o), Y = !!o && Pe(ot(o, n, /* @__PURE__ */ new Date())), F = !!o && o.length >= n.length && !Y || U;
  return /* @__PURE__ */ c(N, { width: l, children: /* @__PURE__ */ c(
    pt,
    {
      arrow: !1,
      lazy: !0,
      visible: p,
      zIndex: a,
      appendTo: d ?? "parent",
      placement: kt,
      onClickOutside: C,
      tippyRef: y,
      content: /* @__PURE__ */ c(
        he,
        {
          ...t,
          onChange: I,
          onChangePanel: m,
          value: o && Y ? ot(o, n, /* @__PURE__ */ new Date()) : void 0,
          minDate: u,
          maxDate: h,
          theme: f
        }
      ),
      children: /* @__PURE__ */ c(
        nt,
        {
          ...k,
          variant: F ? "error" : w,
          disableContentPaddingRight: !0,
          contentRight: D ? void 0 : /* @__PURE__ */ c(E, { alignItems: "center", indent: 0.5, children: /* @__PURE__ */ c(
            A,
            {
              size: "small",
              disabled: k.disabled || r,
              leftIcon: mt,
              onClick: M
            }
          ) }),
          onValueChange: T,
          placeholder: i,
          value: o || "",
          min: u,
          max: h,
          size: 10
        }
      )
    }
  ) });
}, At = (t) => {
  if (t === "")
    return "00";
  const e = parseInt(t, 10);
  if (isNaN(e))
    throw new Error("Hours is not a number");
  if (e < 0 || e > 23)
    throw new Error("Hours is an invalid number");
  switch (t.length) {
    case 1:
      return `0${e}`;
    case 2:
      return t;
    default:
      throw new Error("Invalid hour string");
  }
}, xt = (t) => {
  if (t === "")
    return "00";
  const e = parseInt(t, 10);
  if (isNaN(e))
    throw new Error("Minutes is not a number");
  if (e < 0 || e > 59)
    throw new Error("Minutes is an invalid number");
  switch (t.length) {
    case 1:
      return `0${e}`;
    case 2:
      return t;
    default:
      throw new Error("Invalid minute string");
  }
}, Wn = (t) => {
  if (!Pt(t))
    return { time: t, success: !1 };
  const e = t && t.split(/-|:|,|;|[/]|[.]| /);
  if (e && e.length === 2)
    try {
      const n = At(e[0]), r = xt(e[1]);
      return { time: `${n}:${r}`, success: !0 };
    } catch {
      return { time: t, success: !1 };
    }
  else if (e && e.length === 1) {
    let n = 0, r = 0;
    switch (t.length) {
      case 1:
        return { time: `0${t}:00`, success: !0 };
      case 2:
        const s = parseInt(e[0], 10);
        return s >= 0 && s < 24 ? { time: `${t}:00`, success: !0 } : s >= 24 && s < 59 ? { time: `00:${t}`, success: !0 } : { time: t, success: !1 };
      case 3:
        return r = parseInt(t.substr(1, 2), 10), r >= 0 && r <= 59 ? {
          time: `0${t.substr(0, 1)}:${t.substr(1, 2)}`,
          success: !0
        } : { time: t, success: !1 };
      case 4:
        return n = parseInt(t.substr(0, 2), 10), r = parseInt(t.substr(2, 2), 10), n < 0 || n > 23 ? { time: t, success: !1 } : r < 0 || r > 59 ? { time: t, success: !1 } : {
          time: `${t.substr(0, 2)}:${t.substr(2, 2)}`,
          success: !0
        };
      default:
        return { time: t, success: !1 };
    }
  }
  return { time: t, success: !1 };
}, Pt = (t) => t ? /^[-:.,/; 0-9]+$/.test(t) : !0, Er = ({
  onValueChange: t,
  showPlaceholder: e = !0,
  useIcon: n = !0,
  value: r,
  width: s = "85px",
  variant: i,
  ...d
}) => {
  const [o, l] = S(() => Pt(r)), a = "hh:mm", f = g(() => {
    if (r) {
      const u = Wn(r);
      l(u.success), u.success && t && t(u.time);
    }
  }, [r, t, l]), D = g(
    (u) => {
      const h = u.target.value, w = Pt(h);
      l(w && h.length <= a.length), t && t(h);
    },
    [t, l]
  );
  return /* @__PURE__ */ c(
    nt,
    {
      ...d,
      type: "time",
      variant: o ? i : "error",
      iconLeft: n ? vt : void 0,
      value: r,
      placeholder: e ? a : void 0,
      onChange: D,
      onBlur: f,
      width: s
    }
  );
}, ge = ({
  autoFocusLeft: t,
  autoFocusRight: e,
  onEsc: n,
  onEnter: r,
  onValueChangeLeft: s,
  onValueChangeRight: i,
  separatorIcon: d,
  placeholderLeft: o,
  placeholderRight: l,
  typeLeft: a,
  typeRight: f,
  onChangeLeft: D,
  onChangeRight: u,
  valueLeft: h,
  valueRight: w,
  minLeft: k,
  maxLeft: p,
  minRight: b,
  maxRight: y,
  onClickLeft: m,
  onClickRight: M,
  onClickCalendar: C,
  onClickArrowDown: T,
  onBlurLeft: I,
  onBlurRight: U,
  onFocusLeft: Y,
  onFocusRight: z,
  inputRefLeft: F,
  inputRefRight: O,
  variant: st,
  variantLeft: lt,
  variantRight: it,
  onBlur: J,
  showPresets: at,
  widthLeft: ft,
  widthRight: ut,
  disabled: v
}) => {
  const H = _(0), $ = x(
    () => We((K) => {
      K === 0 && (J == null || J());
    }, 10),
    [J]
  ), Mt = g(
    (K) => {
      H.current++, $(H.current), Y && Y(K);
    },
    [Y, H, $]
  ), Rt = g(
    (K) => {
      H.current++, $(H.current), z && z(K);
    },
    [z, H, $]
  ), Et = g(
    (K) => {
      H.current--, $(H.current), I && I(K);
    },
    [I, H, $]
  ), we = g(
    (K) => {
      H.current--, $(H.current), U && U(K);
    },
    [U, H, $]
  );
  return /* @__PURE__ */ c(N, { children: /* @__PURE__ */ R(
    $e,
    {
      disableContentPaddingRight: !0,
      disabled: v,
      variant: st,
      contentRight: /* @__PURE__ */ R(E, { alignItems: "center", children: [
        /* @__PURE__ */ c(gt, { num: 0.5, children: /* @__PURE__ */ c(
          A,
          {
            leftIcon: mt,
            onClick: C,
            disabled: v,
            size: "small"
          }
        ) }),
        at ? /* @__PURE__ */ R(Dt, { children: [
          /* @__PURE__ */ c(E, { height: "22px", children: /* @__PURE__ */ c(pe, { vertical: !0 }) }),
          /* @__PURE__ */ c(gt, { num: 0.5, children: /* @__PURE__ */ c(
            A,
            {
              leftIcon: Me,
              onClick: T,
              disabled: v,
              size: "small"
            }
          ) })
        ] }) : null
      ] }),
      children: [
        /* @__PURE__ */ c(N, { width: ft, children: /* @__PURE__ */ c(
          nt,
          {
            onEsc: n,
            onEnter: r,
            onClick: m,
            disabled: v,
            hideBorder: !0,
            placeholder: o,
            value: h,
            onValueChange: s,
            onChange: D,
            onBlur: Et,
            onFocus: Mt,
            inputRef: F,
            variant: lt,
            type: a,
            autoFocus: t,
            min: k,
            max: p
          }
        ) }),
        /* @__PURE__ */ c(E, { indent: 0.5, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ c(
          Ft,
          {
            icon: d,
            size: 12,
            color: ce("--lhds-color-ui-500")
          }
        ) }),
        /* @__PURE__ */ c(N, { width: ut, children: /* @__PURE__ */ c(
          nt,
          {
            onEsc: n,
            onEnter: r,
            onClick: M,
            disabled: v,
            hideBorder: !0,
            placeholder: l,
            value: w,
            onValueChange: i,
            onChange: u,
            onBlur: we,
            onFocus: Rt,
            inputRef: O,
            variant: it,
            type: f,
            autoFocus: e,
            min: b,
            max: y
          }
        ) })
      ]
    }
  ) });
}, On = (t) => {
  if (t == null)
    throw new Error("Time is not set.");
  if (t === "")
    throw new Error("Time is empty.");
  const e = t.split(":");
  if (e.length !== 2)
    throw new Error("Invalid time.");
  if (e[1].length !== 2)
    throw new Error("Invalid time.");
  if (e[0].length < 1 || e[0].length > 2)
    throw new Error("Invalid time.");
  const n = parseInt(e[0], 10), r = parseInt(e[1], 10);
  if (isNaN(n))
    throw new Error("Invalid time.");
  if (isNaN(r))
    throw new Error("Invalid time.");
  if (n < 0 || n > 23)
    throw new Error("Invalid time.");
  if (r < 0 || r > 59)
    throw new Error("Invalid time.");
  return n * 100 + r;
}, $n = (t) => {
  try {
    return On(t), !0;
  } catch {
    return !1;
  }
}, Tt = (t) => {
  if (t && $n(t)) {
    const e = t.split(":");
    return {
      hour: Jt(e[0]),
      minute: Jt(e[1])
    };
  }
  return {
    hour: void 0,
    minute: void 0
  };
}, Bn = (t) => `${At(String(t.getHours()))}:${xt(
  String(t.getMinutes())
)}`, jn = "_timePicker_1w05d_1", zn = "_timePickerColumn_1w05d_6", me = {
  timePicker: jn,
  timePickerColumn: zn
}, _n = ({
  onClick: t,
  item: e,
  selected: n,
  columnRef: r,
  canScrollRef: s
}) => {
  const i = _(null);
  return q(
    function() {
      if (n && r.current && i.current && s.current) {
        const o = i.current.scrollHeight * Math.max(e - 2, 0);
        r.current.scrollTo(0, o), s.current = !1;
      }
    },
    [r, e, n, s]
  ), /* @__PURE__ */ c(
    E,
    {
      width: "64px",
      justifyContent: "center",
      spacing: 0.5,
      indent: 0.5,
      ref: i,
      children: n ? /* @__PURE__ */ c(
        dt,
        {
          label: Oe(String(e), 2, "0"),
          onClick: () => t && t(e)
        }
      ) : /* @__PURE__ */ c(
        A,
        {
          label: String(e).padStart(2, "0"),
          onClick: () => t && t(e)
        }
      )
    }
  );
}, qt = ({
  onClick: t,
  items: e,
  selectedItem: n,
  canScrollRef: r
}) => {
  const s = _(null);
  return /* @__PURE__ */ c(B, { className: me.timePickerColumn, ref: s, children: e.map((i) => /* @__PURE__ */ c(
    _n,
    {
      item: i,
      onClick: t,
      selected: i === n,
      columnRef: s,
      canScrollRef: r
    },
    i
  )) });
}, Jn = zt(0, 24), Kn = zt(0, 60), Gn = ({
  value: t,
  onValueChange: e
}) => {
  const n = _(!0), [r, s] = S(void 0), [i, d] = S(void 0);
  q(() => {
    if (t) {
      const { minute: a, hour: f } = Tt(t);
      s(f), d(a);
    }
  }, [t]);
  const o = g(
    (a) => {
      s(a), e == null || e(
        `${At(String(a ?? 0))}:${xt(String(i ?? 0))}`
      );
    },
    [i, e]
  ), l = g(
    (a) => {
      d(a), e == null || e(
        `${At(String(r ?? 0))}:${xt(String(a ?? 0))}`
      );
    },
    [r, e]
  );
  return /* @__PURE__ */ R(E, { className: me.timePicker, children: [
    /* @__PURE__ */ c(
      qt,
      {
        items: Jn,
        onClick: o,
        selectedItem: r,
        canScrollRef: n
      }
    ),
    /* @__PURE__ */ c(gt, {}),
    /* @__PURE__ */ c(
      qt,
      {
        items: Kn,
        onClick: l,
        selectedItem: i,
        canScrollRef: n
      }
    )
  ] });
}, qn = (t, e, n) => {
  q(
    function() {
      t && e(t);
    },
    [t, e]
  ), q(
    function() {
      n.current && (t ? n.current.valueAsDate = new Date(
        Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())
      ) : n.current.valueAsDate = null);
    },
    [t, n]
  );
}, Qn = (t, e, {
  setDateInFocus: n,
  showCalendarInternal: r,
  hideCalendarInternal: s,
  setFirstFocusedInput: i,
  setCurrentPanel: d,
  localTime: o,
  setLocalTime: l,
  localDate: a,
  setLocalDate: f
}, D) => {
  const u = g(
    (y) => {
      if (!y)
        return;
      const m = new Date(y);
      if (t)
        m.setHours(t.getHours()), m.setMinutes(t.getMinutes()), e == null || e(m), f(void 0);
      else if (o) {
        const { minute: M, hour: C } = Tt(o);
        m.setHours(C ?? 0), m.setMinutes(M ?? 0), e == null || e(m), f(void 0);
      } else
        f(m);
      n(m), D.current && (D.current.valueAsDate = new Date(
        Date.UTC(m.getFullYear(), m.getMonth(), m.getDate())
      ));
    },
    [t, D, o, e, n, f]
  ), h = g(
    (y) => {
      if (y)
        if (t) {
          const m = Tt(y), M = new Date(t);
          M.setHours(m.hour || 0), M.setMinutes(m.minute || 0), e == null || e(M), l(void 0);
        } else if (a) {
          const m = Tt(y), M = new Date(a);
          M.setHours(m.hour || 0), M.setMinutes(m.minute || 0), e == null || e(M), l(void 0);
        } else
          l(y);
    },
    [e, t, a, l]
  ), w = g(
    (y) => {
      y.target.value[0] !== "0" && u(y.target.valueAsDate);
    },
    [u]
  ), k = g(
    (y) => h(y.target.value),
    [h]
  ), p = g(() => {
    n(t || /* @__PURE__ */ new Date()), d("calendar"), r();
  }, [t, d, r, n]), b = g(() => {
    i(void 0), s();
  }, [i, s]);
  return {
    inputLeftChangeHandler: w,
    inputRightChangeHandler: k,
    hideCalendar: b,
    showCalendar: p,
    onChangeTime: h,
    onChangeDate: u
  };
}, Xn = (t) => {
  const [e, n] = S(void 0), [r, s] = S(void 0), [i, d, o] = Yt(!1), [l, a, f] = Yt(!1), [D, u] = S(void 0), [h, w] = S(
    () => t ?? /* @__PURE__ */ new Date()
  ), [k, p] = S("calendar");
  return {
    isCalendarVisible: i,
    showCalendarInternal: d,
    hideCalendarInternal: o,
    firstFocusedInput: D,
    setFirstFocusedInput: u,
    dateInFocus: h,
    setDateInFocus: w,
    currentPanel: k,
    setCurrentPanel: p,
    isTimePickerVisible: l,
    showTimePicker: a,
    hideTimePicker: f,
    localDate: e,
    setLocalDate: n,
    localTime: r,
    setLocalTime: s
  };
}, Zn = (t, e, n, r, {
  isCalendarVisible: s,
  setCurrentPanel: i,
  showTimePicker: d,
  hideTimePicker: o
}) => {
  const l = g(() => {
    s || n(), i("calendar"), o();
  }, [o, s, i, n]), a = g(() => {
    r(), d();
  }, [r, d]), f = g(
    (w) => {
      t(w.date), r(), d();
    },
    [t, r, d]
  ), D = g(() => {
    i("presets"), n();
  }, [i, n]), u = g(() => {
    var w;
    s ? r() : ((w = e.current) == null || w.focus(), i("calendar"), n());
  }, [
    s,
    r,
    e,
    i,
    n
  ]), h = g(
    (w) => {
      w.key === "Escape" && r();
    },
    [r]
  );
  return {
    onFocusLeft: l,
    onFocusRight: a,
    onClickDay: f,
    onClickArrowButton: D,
    onClickCalendarButton: u,
    onKeyDownHandler: h
  };
}, Tr = ({
  value: t,
  onValueChange: e,
  onEnter: n,
  onEsc: r,
  onBlur: s,
  autoFocus: i,
  minDate: d,
  widthLeft: o = 128,
  widthRight: l = 80,
  maxDate: a = St,
  variant: f,
  disabled: D
}) => {
  const u = _(null), h = _(null), w = Xn(t), {
    setCurrentPanel: k,
    currentPanel: p,
    isCalendarVisible: b,
    dateInFocus: y,
    setDateInFocus: m,
    isTimePickerVisible: M,
    hideTimePicker: C,
    localTime: T,
    localDate: I
  } = w, {
    showCalendar: U,
    hideCalendar: Y,
    inputLeftChangeHandler: z,
    inputRightChangeHandler: F,
    onChangeTime: O,
    onChangeDate: st
  } = Qn(t, e, w, u), {
    onKeyDownHandler: lt,
    onFocusRight: it,
    onFocusLeft: J,
    onClickDay: at,
    onClickCalendarButton: ft,
    onClickArrowButton: ut
  } = Zn(
    st,
    u,
    U,
    Y,
    w
  );
  qn(t, m, u);
  const v = x(() => {
    const Et = t || I;
    return Et ? Q(void 0, Et, [
      "singleSelected",
      "selected"
    ]) : {};
  }, [I, t]), H = g(() => {
    Y(), C();
  }, [Y, C]), $ = x(
    () => t ? Bn(t) : T,
    [t, T]
  ), Mt = Ht(b, 300), Rt = Ht(M, 300);
  return /* @__PURE__ */ c(N, { onKeyDown: lt, children: /* @__PURE__ */ c(
    pt,
    {
      arrow: !1,
      lazy: !0,
      disabled: D,
      placement: kt,
      visible: b || M,
      onClickOutside: H,
      content: (Mt || Rt) && /* @__PURE__ */ c(B, { children: Mt ? /* @__PURE__ */ c(
        Z,
        {
          statePerMonth: v,
          onClickDay: at,
          dateInFocus: y,
          setDateInFocus: m,
          currentPanel: p,
          setCurrentPanel: k,
          minDate: d,
          maxDate: a
        }
      ) : Rt ? /* @__PURE__ */ R(B, { children: [
        /* @__PURE__ */ c(B, { overflow: "hidden", height: "250px", children: /* @__PURE__ */ c(
          Gn,
          {
            value: $ ?? "",
            onValueChange: O
          }
        ) }),
        /* @__PURE__ */ c(W, {}),
        /* @__PURE__ */ c(E, { justifyContent: "flex-end", children: /* @__PURE__ */ c(dt, { label: "Done", onClick: C }) })
      ] }) : null }),
      children: /* @__PURE__ */ c(
        ge,
        {
          autoFocusLeft: i,
          onEsc: r,
          onEnter: n,
          onBlur: s,
          disabled: D,
          separatorIcon: vt,
          typeLeft: "date",
          typeRight: "time",
          placeholderLeft: "yyyy-mm-dd",
          placeholderRight: "hh:mm",
          onChangeLeft: z,
          onChangeRight: F,
          onClickArrowDown: ut,
          onClickCalendar: ft,
          onFocusLeft: J,
          onFocusRight: it,
          onClickLeft: J,
          onClickRight: it,
          inputRefLeft: u,
          inputRefRight: h,
          valueRight: $ ?? "",
          widthLeft: o,
          widthRight: l,
          minLeft: d,
          maxLeft: a,
          variant: f
        }
      )
    }
  ) });
}, Fn = (t, e, n, r, s) => {
  q(
    function() {
      t && n(t);
    },
    [t, n]
  ), q(
    function() {
      e && n(e);
    },
    [e, n]
  ), q(
    function() {
      r.current && (t ? r.current.valueAsDate = new Date(
        Date.UTC(
          t.getFullYear(),
          t.getMonth(),
          t.getDate()
        )
      ) : r.current.valueAsDate = null);
    },
    [t, r]
  ), q(
    function() {
      s.current && (e ? s.current.valueAsDate = new Date(
        Date.UTC(
          e.getFullYear(),
          e.getMonth(),
          e.getDate()
        )
      ) : s.current.valueAsDate = null);
    },
    [e, s]
  );
}, vn = (t, e, n, {
  setDateInFocus: r,
  showCalendarInternal: s,
  hideCalendarInternal: i,
  setFirstFocusedInput: d,
  setCurrentPanel: o
}) => {
  const l = g(
    (u) => {
      u.target.value[0] !== "0" && (n == null || n({
        startDate: u.target.valueAsDate ?? void 0,
        endDate: e
      }));
    },
    [n, e]
  ), a = g(
    (u) => {
      u.target.value[0] !== "0" && (n == null || n({
        startDate: t,
        endDate: u.target.valueAsDate ?? void 0
      }));
    },
    [n, t]
  ), f = g(() => {
    r(t || e || /* @__PURE__ */ new Date()), o("calendar"), s();
  }, [
    t,
    e,
    o,
    s,
    r
  ]), D = g(() => {
    d(void 0), i();
  }, [d, i]);
  return {
    inputLeftChangeHandler: l,
    inputRightChangeHandler: a,
    hideCalendar: D,
    setDateInFocus: r,
    setCurrentPanel: o,
    showCalendar: f
  };
}, Vn = (t, e) => {
  const [n, r, s] = Yt(!1), [i, d] = S(void 0), [o, l] = S("startDate"), [a, f] = S(() => (o === "startDate" ? t : o === "endDate" ? e : void 0) ?? /* @__PURE__ */ new Date()), [D, u] = S("calendar");
  return {
    isCalendarVisible: n,
    showCalendarInternal: r,
    hideCalendarInternal: s,
    firstFocusedInput: i,
    setFirstFocusedInput: d,
    focusedInput: o,
    setFocusedInput: l,
    dateInFocus: a,
    setDateInFocus: f,
    currentPanel: D,
    setCurrentPanel: u
  };
}, tr = (t, e, n, r, s, i, d, {
  firstFocusedInput: o,
  setFirstFocusedInput: l,
  isCalendarVisible: a,
  setFocusedInput: f,
  focusedInput: D,
  setCurrentPanel: u
}) => {
  const h = g(() => {
    o == null && l("startDate"), f("startDate"), a || i();
  }, [
    a,
    f,
    i,
    l,
    o
  ]), w = g(() => {
    o == null && l("endDate"), f("endDate"), a || i();
  }, [
    a,
    f,
    i,
    l,
    o
  ]), k = g(
    (m) => {
      var M, C, T, I;
      D === "startDate" ? e != null && et(m.date, e) ? (n == null || n({
        startDate: m.date,
        endDate: void 0
      }), f("endDate"), (M = s.current) == null || M.focus()) : (n == null || n({
        startDate: m.date,
        endDate: e
      }), o === "startDate" ? (f("endDate"), (C = s.current) == null || C.focus()) : setTimeout(d, 50)) : D === "endDate" && (t ? et(t, m.date) ? (n == null || n({
        startDate: m.date,
        endDate: void 0
      }), f("endDate"), (I = s.current) == null || I.focus()) : (n == null || n({
        startDate: t,
        endDate: m.date
      }), setTimeout(d, 50)) : (n == null || n({
        startDate: t,
        endDate: m.date
      }), f("startDate"), (T = r.current) == null || T.focus()));
    },
    [
      D,
      n,
      e,
      o,
      f,
      s,
      d,
      t,
      r
    ]
  ), p = g(() => {
    u("presets"), i();
  }, [u, i]), b = g(() => {
    var m;
    a ? d() : (f("startDate"), l("startDate"), (m = r.current) == null || m.focus(), u("calendar"), i());
  }, [
    a,
    d,
    f,
    l,
    r,
    u,
    i
  ]), y = g(
    (m) => {
      m.key === "Escape" && d();
    },
    [d]
  );
  return {
    onFocusLeft: h,
    onFocusRight: w,
    onClickDay: k,
    onClickArrowButton: p,
    onClickCalendarButton: b,
    onKeyDownHandler: y
  };
};
function Ar({
  value: t,
  onValueChange: e,
  autoFocus: n,
  onBlur: r,
  onEnter: s,
  onEsc: i,
  minDate: d,
  maxDate: o = St,
  calendarProps: l,
  widthLeft: a = 128,
  widthRight: f = 128,
  variant: D,
  disabled: u
}) {
  const { startDate: h, endDate: w } = t || {}, k = _(null), p = _(null), b = Vn(h, w), {
    dateInFocus: y,
    setDateInFocus: m,
    isCalendarVisible: M,
    currentPanel: C,
    setCurrentPanel: T
  } = b, {
    showCalendar: I,
    hideCalendar: U,
    inputLeftChangeHandler: Y,
    inputRightChangeHandler: z
  } = vn(h, w, e, b), {
    onKeyDownHandler: F,
    onFocusRight: O,
    onFocusLeft: st,
    onClickDay: lt,
    onClickCalendarButton: it,
    onClickArrowButton: J
  } = tr(
    h,
    w,
    e,
    k,
    p,
    I,
    U,
    b
  );
  Fn(
    h,
    w,
    m,
    k,
    p
  );
  const at = x(
    () => h && w && et(h, w),
    [h, w]
  ), ft = x(
    () => je(
      l == null ? void 0 : l.statePerMonth,
      h,
      w,
      y
    ),
    [l == null ? void 0 : l.statePerMonth, h, w, y]
  ), ut = Ht(M, 300);
  return /* @__PURE__ */ c(N, { onKeyDown: F, children: /* @__PURE__ */ c(
    pt,
    {
      arrow: !1,
      lazy: !0,
      disabled: u,
      placement: kt,
      onClickOutside: U,
      visible: M,
      content: ut && /* @__PURE__ */ c(
        Z,
        {
          onClickDay: lt,
          dateInFocus: y,
          setDateInFocus: m,
          currentPanel: C,
          setCurrentPanel: T,
          minDate: d,
          maxDate: o,
          ...l,
          statePerMonth: ft
        }
      ),
      children: /* @__PURE__ */ c(
        ge,
        {
          autoFocusLeft: n,
          onEsc: i,
          onEnter: s,
          onBlur: r,
          disabled: u,
          separatorIcon: Qt,
          typeLeft: "date",
          typeRight: "date",
          placeholderLeft: "Start date",
          placeholderRight: "End date",
          onChangeLeft: Y,
          onChangeRight: z,
          onClickArrowDown: J,
          onClickCalendar: it,
          onFocusLeft: st,
          onFocusRight: O,
          onClickLeft: st,
          onClickRight: O,
          inputRefLeft: k,
          inputRefRight: p,
          variant: at ? "error" : D,
          widthLeft: a,
          widthRight: f,
          minLeft: d,
          maxLeft: o,
          minRight: d,
          maxRight: o
        }
      )
    }
  ) });
}
export {
  Lt as Calendar,
  le as CalendarDay,
  Sr as DateInput,
  wr as DateRangeCalendar,
  Ar as DateRangeDualTextInput,
  kr as DateRangeExclusionCalendar,
  Mr as DateRangeInput,
  Rr as DateTextInput,
  Tr as DateTimeInput,
  L as Month,
  Dn as MonthPicker,
  pr as MultiDateCalendar,
  mn as PresetPicker,
  he as SingleDateCalendar,
  br as SingleWeekCalendar,
  Er as TimeTextInput,
  Ke as WeekDay,
  cn as WeekDayCell,
  rn as WeekNumberCell,
  yn as YearPicker,
  Q as addDayStateHighlights,
  oe as addDayStateHighlightsOnSingleDay,
  _e as addWeekRangeHighlights,
  Dr as addWeekStateHighlights,
  yt as buildDayStateForDateRange,
  ze as buildDayStateForRange,
  je as buildDayStateForSingleMonth,
  Xe as calculateOverflowingMonth,
  qe as createDay,
  En as dateRangeToStrings,
  ve as dayHasHighlight,
  V as dayHighlightSelect,
  rt as defaultCalendarTheme,
  tn as defaultTextPropsProvider,
  Ve as defaultWrapperStyleProvider,
  gr as extranetCalendarTheme,
  Qe as getDaysForWeekForDate,
  de as getMonthInYear,
  Kt as getMonthsInYear,
  _t as getWeekForDate,
  Ge as getWeeksForMonth,
  ae as isDateRangeInvalid,
  ur as setDayStateValue,
  hr as setDayStateValueFunction,
  Tn as stringsToDateRange,
  mr as toggleDateStringsIfEndIsEarlierThanStart,
  fe as toggleDatesIfEndIsEarlierThanStart,
  yr as useDateRangeCalendarState,
  Hn as useDateRangeExclusionSelection,
  An as useDateRangeSelection,
  Cn as useMultiDateSelection,
  xn as useSingleDateSelection,
  In as useSingleWeekSelection
};
//# sourceMappingURL=index.es.js.map
